// extracted by mini-css-extract-plugin
export default {"container":"hawk-tabletop-container"};